module.exports = __webpack_public_path__ + "img/medal_main_center.bfa163e0.png";